export default "__VITE_ASSET__FiT7wCNl__"